import React from "react";
import { mutate } from "swr";
import { useSnapshot } from "valtio";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
import { useTranslation } from "react-i18next";
import { store } from "@components/VerticalLayout/store";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";
import { SaveButtonComponent } from "./SaveButtonComponent";
import { ConfigElement } from "./ConfigElement";
import { ModalHeaderComponent } from "./ModalHeaderComponent";
import { useFetchGlobal } from "../../../../api/hooks";

type PropsType = {
    setIsOpen: (value: boolean) => void;
    isOpen: boolean;
    setIsLoading: Function;
    setNumberClick: Function;
};

export function DefaultSettingModal({
    setIsOpen,
    isOpen,
    setIsLoading,
    setNumberClick,
}: PropsType): JSX.Element {
    const { fetchGlobal } = useFetchGlobal();
    const { t } = useTranslation();
    const { franchiseID, shopID } = useSnapshot(store);

    async function InsertEditorPos(franchiseId: string) {
        const url = `${process.env.REACT_APP_API_V2_URL}/settings/general/insertPosEditor`;
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                franchiseId: franchiseId,
                shopId: shopID,
            }),
        };
        try {
            const data: any = await fetchGlobal<any>(url, requestOptions);

            if (data.error) {
            }

            mutate(url, data);
        } catch (e) {
            throw e;
        }
    }
    return (
        <React.Fragment>
            <Modal
                centered
                backdrop="static"
                fade={false}
                scrollable
                isOpen={isOpen}
            >
                <ModalHeaderComponent
                    setIsOpen={setIsOpen}
                    isOpen={isOpen}
                    setNumberClick={setNumberClick}
                    InsertEditorPos={() => InsertEditorPos(franchiseID)}
                />
                <ModalBody className="ml-2">
                    <ConfigElement />
                </ModalBody>
                <ModalFooter>
                    <CustomSecondaryColorButton
                        className="w-20 kds_btn_validateTemplate"
                        rounded
                        variant="primary"
                        onClick={() => {
                            setIsOpen(!isOpen);
                            setNumberClick(1);
                            InsertEditorPos(franchiseID);
                        }}
                    >
                        {t("Annuler")}
                    </CustomSecondaryColorButton>
                    <SaveButtonComponent
                        setIsOpen={setIsOpen}
                        isOpen={isOpen}
                        setIsLoading={setIsLoading}
                    />
                </ModalFooter>
            </Modal>
        </React.Fragment>
    );
}
